import { api } from "../api/Middleware";
import { GOOGLE_CALENDAR_URL } from "../api/Urls";


export const ListGoogleCalendarIntegrations = async () => {
  try {
    const response = await api.get(`${GOOGLE_CALENDAR_URL}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const CreateGoogleCalendarIntegration = async (formData) => {
  try {
    const response = await api.post(`${GOOGLE_CALENDAR_URL}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (response.status === 201) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const GetGoogleCalendarIntegration = async (integrationId) => {
  try {
    const response = await api.get(`${GOOGLE_CALENDAR_URL}${integrationId}/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const UpdateGoogleCalendarIntegration = async (integrationId, payload) => {
  try {
    const response = await api.put(`${GOOGLE_CALENDAR_URL}${integrationId}/`, payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const DeleteGoogleCalendarIntegration = async (integrationId) => {
  try {
    const response = await api.delete(`${GOOGLE_CALENDAR_URL}${integrationId}/`);
    if (response.status === 204) {
      return true;
    }
  } catch (error) {
    throw error.response;
  }
};

export const UploadGoogleCalendarCredentials = async (formData) => {
  try {
    const response = await api.post(`${GOOGLE_CALENDAR_URL}upload-credentials/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const TestGoogleCalendarConnection = async (integrationId) => {
  try {
    const response = await api.post(`${GOOGLE_CALENDAR_URL}${integrationId}/test-connection/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const ConfigureGoogleCalendar = async (integrationId, payload) => {
  try {
    const response = await api.post(`${GOOGLE_CALENDAR_URL}${integrationId}/configure-calendar/`, payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const ListGoogleCalendars = async (integrationId) => {
  try {
    const response = await api.get(`${GOOGLE_CALENDAR_URL}${integrationId}/calendars/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};